import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ProfileService } from 'src/app/_services/profile.service';
import { ReviewService } from 'src/app/_services/review.service';
import { BaseComponent } from '../../../base/base.component';

@Component({
  selector: 'app-how-is-going',
  templateUrl: './how-is-going.component.html',
  styleUrls: ['./how-is-going.component.css']
})
export class HowIsGoingComponent extends BaseComponent {
  /**
   * Se arriva chosenUser vuol dire che stiamo facendo la review ad un altra persona
   */
  @Input() chosenUser?: string;
  @Input() isVisible: boolean;
  @Input() isEdit: boolean = false;
  @Input() selectedReviewId: number;

  @Output() isCompleteChange = new EventEmitter<boolean>();

  isComplete: boolean = false;
  howIsGoing: string = '';
  isValidHowIsGoing: boolean = true;
  existHowIsGoing: boolean = false;
  thoughtsAboutYou: string = '';
  isValidThoughtsAboutYou: boolean = true;
  existThoughtsAboutYou: boolean = false;
  profileData: any;
  userRole: any;
  userReveal: boolean = false;
  reviewerReveal: boolean = false;
  isLoggedUser: boolean = false;

  destroy$ = new Subject<void>();

  constructor(
    private readonly profileService: ProfileService,
    private readonly reviewService: ReviewService
  ) {
    super();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (
      this.isVisible &&
      (changes['chosenUser']?.currentValue || this.chosenUser) &&
      changes['selectedReviewId']?.currentValue
    ) {
      this.profileData = await this.profileService.getUserRoleAsync();
      this.userRole = this.profileData.roles[0];

      if (changes['chosenUser']?.currentValue == this.profileData?.id) {
        this.isLoggedUser = true;
      }
      this.getHowIsGoing();
    }
  }

  /*
    Funzione per la verifica e la validazione del testo inserito nella sezione 'Come sta andando',
    assicurandosi che non contenga solo spazi vuoti.
  */
  changeHowIsGoing(event: string) {
    this.isValidHowIsGoing = event.trim().length === 0;
  }

  /*
    Funzione per la verifica e la validazione del testo inserito nella sezione 'Cosa pensiamo di te',
    assicurandosi che non contenga solo spazi vuoti.
  */
  changeThoughtsAboutYou(event: string) {
    this.isValidThoughtsAboutYou = event.trim().length === 0;
  }

  getHowIsGoing() {
    this.reviewService
      .getReviewHowIsGoing(this.chosenUser, this.selectedReviewId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          // se non esiste una review settiamo di default il testo in base all'utente loggato o all'utente a cui stiamo facendo la review
          if (res.error && this.chosenUser && this.isLoggedUser == false) {
            this.howIsGoing =
              'Ci hai provato. Davvero, un tentativo ammirevole. Hai aperto gli strumenti per sviluppatori, hai navigato tra gli stili CSS, hai individuato quel fastidioso filter: blur(5px), lo hai disattivato con un colpo di tastiera... e niente. La frase è rimasta lì, imperturbabile, ancora avvolta nel mistero. Forse hai pensato: "Magari è nascosta sotto un altro div, forse è un\'immagine, forse il testo è stato semplicemente rimosso dal DOM!" E così hai scavato più a fondo, hai analizzato gli elementi, cercato nel codice sorgente, provato con l\'Inspector... Ma no, niente da fare. Il blur era solo un ostacolo di facciata. La vera barriera era più subdola. Il testo? Inaccessibile. Protetto. Invisibile ai tuoi occhi curiosi. Ed eccoti qui, con un leggero sorriso e un pizzico di frustrazione, ammettendo che sì, ci hai provato. Hai dimostrato ingegno, determinazione, persino un po’ di astuzia. Ma alla fine, il risultato è lo stesso: il segreto resta tale. Non preoccuparti, però. La conoscenza arriva con l’esperienza, e oggi hai imparato qualcosa di nuovo. La prossima volta, magari, troverai un modo migliore... o forse capirai che alcune cose sono fatte apposta per rimanere nascoste. Ma davvero, bel tentativo.';
            this.thoughtsAboutYou = '';
          } else if (res.error && !this.chosenUser) {
            this.thoughtsAboutYou =
              'Ci hai provato. Davvero, un tentativo ammirevole. Hai aperto gli strumenti per sviluppatori, hai navigato tra gli stili CSS, hai individuato quel fastidioso filter: blur(5px), lo hai disattivato con un colpo di tastiera... e niente. La frase è rimasta lì, imperturbabile, ancora avvolta nel mistero. Forse hai pensato: "Magari è nascosta sotto un altro div, forse è un\'immagine, forse il testo è stato semplicemente rimosso dal DOM!" E così hai scavato più a fondo, hai analizzato gli elementi, cercato nel codice sorgente, provato con l\'Inspector... Ma no, niente da fare. Il blur era solo un ostacolo di facciata. La vera barriera era più subdola. Il testo? Inaccessibile. Protetto. Invisibile ai tuoi occhi curiosi. Ed eccoti qui, con un leggero sorriso e un pizzico di frustrazione, ammettendo che sì, ci hai provato. Hai dimostrato ingegno, determinazione, persino un po’ di astuzia. Ma alla fine, il risultato è lo stesso: il segreto resta tale. Non preoccuparti, però. La conoscenza arriva con l’esperienza, e oggi hai imparato qualcosa di nuovo. La prossima volta, magari, troverai un modo migliore... o forse capirai che alcune cose sono fatte apposta per rimanere nascoste. Ma davvero, bel tentativo.';
            this.thoughtsAboutYou = '';
          } else {
            this.howIsGoing = res.how_is_going;
            this.thoughtsAboutYou = res.review;
          }
          this.existHowIsGoing = !!res.how_is_going;
          this.existThoughtsAboutYou = !!res.review;
          this.userReveal = res.user_reveal;
          this.reviewerReveal = res.reviewer_reveal;

          if (this.userReveal && this.reviewerReveal) {
            this.isComplete = true;
            this.isCompleteChange.emit(this.isComplete);
          }
        },
        error: (err: any) => {
          this.responseToast('error', 'Qualcosa è andato storto');
        }
      });
  }

  /**
   * Funzione che serve per salvare il Come sta andando
   */
  saveHowIsGoing() {
    this.reviewService
      .reviewHowIsGoing({ review: this.howIsGoing })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.getHowIsGoing();
        },
        error: (err: any) => {
          this.responseToast('error', 'Qualcosa è andato storto');
        }
      });
  }

  /**
   * Funzione che serve per salvare il Cosa pensiamo di te
   */
  saveThoughtsAboutYou() {
    this.reviewService
      .reviewHowIsGoing({
        review: this.thoughtsAboutYou,
        id: this.chosenUser
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.getHowIsGoing();
        },
        error: (err: any) => {
          this.responseToast('error', 'Qualcosa è andato storto');
        }
      });
  }

  /**
   * Funzione che serve per cmabiare lo stato del reveal
   */
  setReveal() {
    this.reviewService
      .setReveals(this.chosenUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.getHowIsGoing();
        },
        error: (err: any) => {
          this.responseToast('error', err.message);
        }
      });
  }

  allAllowed() {
    if (this.userReveal && this.reviewerReveal) return true;
    return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
